import { Controller } from "@hotwired/stimulus"

// Core features tab switcher: clicking a tab highlights it and fades in the
// matching panel image. Tabs and panels are paired by their target order.
export default class extends Controller {
  static targets = [ "tab", "panel" ]
  static values = { index: { type: Number, default: 0 } }

  connect() {
    this.render()
  }

  select(event) {
    this.indexValue = this.tabTargets.indexOf(event.currentTarget)
  }

  indexValueChanged() {
    this.render()
  }

  render() {
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle("active", i === this.indexValue)
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("opacity-0", i !== this.indexValue)
    })
  }
}
